module.exports = __webpack_public_path__ + "img/icon_3.589a2e60.png";